const Loader = ({loading, spinner, children}) => (loading ? spinner : children);

export default Loader;
